module.exports = __webpack_public_path__ + "media/src/img/payment/mastercard_logo-5379a24569719f7b887defe691eb3604.png";